<template>
    <div>
        <div v-if="canViewDefinition" class="table-browser-word-break">
            {{ item.shortDefinition }}
        </div>

        <template>
            <template v-if="canViewReference || canViewComment">
                <hr>
            </template>
            <div v-if="canViewReference">
                <!-- References and comments are SafeRichTextField, No need to sanitise -->
                <small>References:
                    <div v-html="item.references" />
                </small>
            </div>

            <div v-if="canViewComment">
                <small>Comments:
                    <div v-html="item.comments" />
                </small>
            </div>
        </template>

        <!-- When the list contains all metadata type-->
        <template v-if="isAllMetadata && canViewChildren">
            <template v-if="item[caseFoldMetadataType]">
                <template v-if="hasChildren">
                    <hr>
                </template>
                <div v-for="(child, index) in metadataTypeChildren" :key="index">
                    <div v-if="item[caseFoldMetadataType][child]">
                        <small>
                            {{ item[caseFoldMetadataType][child].__typename | removeLastWord }}: {{ item[caseFoldMetadataType][child].name }}
                        </small>
                    </div>
                </div>
            </template>
        </template>

        <!-- When the list contains a specific metadata type-->
        <template v-if="isMetadataTypeThatHasChildren && canViewChildren">
            <template v-if="hasChildren">
                <hr>
            </template>
            <div v-for="(child, index) in metadataTypeChildren" :key="index">
                <div v-if="item[child]">
                    <small>{{ item[child].__typename | removeLastWord }}: {{ item[child].name }}</small>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: "MetadataDetail",

    filters: {
        removeLastWord: function (value) {
            // The input value would always be in the format of <type>Node.
            // For example, ObjectClassNode.
            // This function aims to remove the last word, 'Node' from the input value
            if (!value) return ''
            let new_string = value.split(/(?=[A-Z])/) // Split by capital letter
            new_string.pop() // Remove the last word
            return new_string.join(' ')
        }
    },

    props: {
        item: {
            type: Object,
            required: true
        },

        visibleDetailOption: {
            type: Object,
            required: true
        },

        queryOperation: {
            type: String,
            required: true
        }
    },

    computed: {
        // Check if the current query operation is on retrieving all metadata
        isAllMetadata() {
            return this.queryOperation === 'metadata'
        },

        // Only allow specific metadata type to display children
        isMetadataTypeThatHasChildren() {
            return this.queryOperation === 'dataElements' || this.queryOperation === 'dataElementConcepts' ||
                this.queryOperation === 'valueDomains' || this.queryOperation === 'unitOfMeasures'
        },

        canViewDefinition() {
            return this.visibleDetailOption.shortDefinition.selected
        },

        canViewComment() {
            return this.item.comments && this.visibleDetailOption.comments.selected
        },

        canViewReference() {
            return this.item.references && this.visibleDetailOption.references.selected
        },

        canViewChildren() {
            return this.visibleDetailOption.children.selected
        },

        metadataTypeChildren() {
            switch (this.item.metadataTypeName) {
                case 'Data Element':
                    return ['dataElementConcept', 'valueDomain']
                case 'Data Element Concept':
                    return ['objectClass', 'property']
                case 'Value Domain':
                    return ['dataType', 'unitOfMeasure']
                case 'Unit Of Measure':
                    return ['measure']
                default:
                    return []
            }
        },

        hasChildren() {
            // Check if the item has children defined
            const children = this.metadataTypeChildren
            const parent = this.caseFoldMetadataType
            let childrenCounter = 0
            if (children.length) {
                for (let i = 0; i < children.length; i++) {
                    // Different query operations have different syntax to access the children
                    if (this.isAllMetadata && this.item[parent][children[i]]) {
                        childrenCounter += 1
                    } else if (this.isMetadataTypeThatHasChildren && this.item[children[i]]) {
                        childrenCounter += 1
                    }
                }
            }
            return childrenCounter > 0
        },

        caseFoldMetadataType() {
            // Need to flatten the metadata type name to access a specific field in graphql].
            // From example, flat case of "Conceptual Domain" is "conceptualdomain"
            return this.item.metadataTypeName.toLowerCase().split(" ").join("")
        }
    },
}
</script>
